import { i18n } from '../../lang'

export const columnList = [
  { type: 'id', custom: { width: 60 } },
  { type: 'order_date', custom: { width: 86 }, title: `${i18n.t('table.date')} (HKT)` },
  { type: 'member_id', custom: { width: 86 } },
  { type: 'affiliate_order_id', custom: { width: 120 } },
  { type: 'is_valid', custom: { width: 52 } },
  { type: 'is_settle', custom: { width: 62 } },
  { type: 'is_handling', custom: { width: 72 } },
  { type: 'reason', custom: { minWidth: 180 } },
  { type: 'uploads', custom: { width: 74 } },
  { type: 'remarks', custom: { minWidth: 180 } },
]

export const validOptions = [
  { key: undefined, label: 'All' },
  { key: 1, label: 'Valid' },
  { key: 0, label: 'Invalid' },
]
export const settleOptions = [
  { key: undefined, label: 'All' },
  { key: 1, label: 'Settled' },
  { key: 0, label: 'Pending' },
]

export const appealFormTemplate = [
  {
    key: 'is_valid',
    isRadio: true,
    list: validOptions.slice(1),
    optionValue: 'key',
  },
  {
    key: 'is_handling',
    isSwitch: true,
  },
  {
    key: 'is_settle',
    isSwitch: true,
  },
  {
    key: 'remarks',
    isInput: true,
    custom: {
      type: 'textarea',
    },
  },
]
